import { render, staticRenderFns } from "./ClvModalTransliteration.vue?vue&type=template&id=08bb2b9c&"
import script from "./ClvModalTransliteration.vue?vue&type=script&lang=js&"
export * from "./ClvModalTransliteration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports